export default {"src":"/_next/static/media/close-green.bb345a96.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};